function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 10.2253C10.5 6.18943 4.33333 7.29013 4.33333 5.35992C4.33333 4.81755 4.85 4.54636 5.61667 4.54636C6.33727 4.54636 7.40309 4.82171 8.41407 5.25405C8.93667 5.47754 9.56299 5.28794 9.81864 4.7803L10.0556 4.30968C10.2884 3.84752 10.1314 3.27898 9.66028 3.06506C8.78689 2.66852 7.75287 2.38913 6.7 2.28116V0.999999C6.7 0.447715 6.25229 0 5.7 0H5.5C4.94772 0 4.5 0.447715 4.5 1V2.36092C2.48333 2.72782 1.21667 3.90828 1.21667 5.61516C1.21667 9.57129 7.38333 8.39083 7.38333 10.3689C7.38333 11.007 6.8 11.342 5.86667 11.342C4.96157 11.342 3.73365 10.9712 2.67008 10.3676C2.11579 10.053 1.36976 10.1996 1.07297 10.7636L0.886283 11.1184C0.662279 11.544 0.770042 12.0747 1.17889 12.3282C2.14049 12.9243 3.29887 13.3486 4.5 13.5274V15C4.5 15.5523 4.94771 16 5.5 16H5.7C6.25229 16 6.7 15.5523 6.7 15V13.5912C8.88333 13.3519 10.5 12.2034 10.5 10.2253Z",
  fill: "#FFE600"
});

function SvgIcon16Dollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16Dollar);
export default __webpack_public_path__ + "static/media/icon-16-dollar.6bb462f2.svg";
export { ForwardRef as ReactComponent };